import {type RefObject, useCallback, useEffect, useLayoutEffect, useRef} from "react";

import type {GetSemanticSearchStoreResponseDto} from "../types/GetSemanticSearchStoreResponseDto";

const DEFAULT_SCROLL_OFFSET = 24;

export interface UseSemanticSearchConversationScrollOptions {
    scrollOffset?: number;
    containerRef?: RefObject<HTMLElement | null>;
}

export function useSemanticSearchConversationScroll(
    semanticSearchHistory: GetSemanticSearchStoreResponseDto | undefined,
    options: UseSemanticSearchConversationScrollOptions = {}
) {
    const {scrollOffset = DEFAULT_SCROLL_OFFSET, containerRef} = options;

    const lastUserMessageRef = useRef<HTMLDivElement>(null);
    const lastApiResponseRef = useRef<HTMLDivElement>(null);
    const userHasScrolledRef = useRef(false);
    const lastScrollTopRef = useRef(0);

    const lastUserInputIndex = semanticSearchHistory
        ? semanticSearchHistory.reduce((lastIndex, item, index) => (item.type === "USER_INPUT" ? index : lastIndex), -1)
        : -1;

    const lastApiResponseIndex = semanticSearchHistory
        ? semanticSearchHistory.reduce((lastIndex, item, index) => (item.type === "API_RESPONSE" && index > lastUserInputIndex ? index : lastIndex), -1)
        : -1;

    const scrollToLastUserMessage = useCallback(
        (behavior: ScrollBehavior = "smooth") => {
            const target = lastUserMessageRef.current;
            if (!target) return;

            if (containerRef?.current) {
                const container = containerRef.current;
                const targetRect = target.getBoundingClientRect();
                const containerRect = container.getBoundingClientRect();
                const relativeTop = targetRect.top - containerRect.top;
                const newScrollTop = container.scrollTop + relativeTop - scrollOffset;

                userHasScrolledRef.current = false;
                lastScrollTopRef.current = Math.max(0, newScrollTop);

                container.scrollTo({
                    top: lastScrollTopRef.current,
                    behavior
                });
            } else {
                const targetRect = target.getBoundingClientRect();
                const scrollTop = window.scrollY || document.documentElement.scrollTop;
                const targetPosition = targetRect.top + scrollTop - scrollOffset;

                window.scrollTo({
                    top: Math.max(0, targetPosition),
                    behavior
                });
            }
        },
        [containerRef, scrollOffset]
    );

    useLayoutEffect(() => {
        const useContainer = Boolean(containerRef);
        const id = useContainer ? window.setTimeout(() => scrollToLastUserMessage("auto"), 80) : requestAnimationFrame(() => scrollToLastUserMessage("auto"));

        return () => (useContainer ? clearTimeout(id as number) : cancelAnimationFrame(id as number));
    }, [lastUserInputIndex, lastApiResponseIndex, scrollToLastUserMessage, containerRef]);

    useEffect(() => {
        const container = containerRef?.current;
        const lastApiResponseEl = lastApiResponseRef.current;
        const lastUserMessageEl = lastUserMessageRef.current;

        if (!lastApiResponseEl || !lastUserMessageEl) return;

        const handleUserScroll = () => {
            if (!container) return;

            const currentScrollTop = container.scrollTop;

            if (Math.abs(currentScrollTop - lastScrollTopRef.current) > 10) {
                userHasScrolledRef.current = true;
            }
        };

        const handleResize = () => {
            if (!userHasScrolledRef.current) {
                scrollToLastUserMessage("smooth");
            }
        };

        const resizeObserver = new ResizeObserver(handleResize);

        resizeObserver.observe(lastApiResponseEl);
        resizeObserver.observe(lastUserMessageEl);

        if (container) {
            resizeObserver.observe(container);
            container.addEventListener("scroll", handleUserScroll, {passive: true});
        }

        window.addEventListener("resize", handleResize);

        return () => {
            resizeObserver.disconnect();

            window.removeEventListener("resize", handleResize);

            if (container) {
                container.removeEventListener("scroll", handleUserScroll);
            }
        };
    }, [lastUserInputIndex, lastApiResponseIndex, scrollToLastUserMessage, containerRef]);

    useEffect(() => {
        if (!semanticSearchHistory || semanticSearchHistory.length === 0) return;

        userHasScrolledRef.current = false;

        const timeoutId = setTimeout(() => {
            scrollToLastUserMessage("smooth");
        }, 100);

        return () => clearTimeout(timeoutId);
    }, [semanticSearchHistory, scrollToLastUserMessage]);

    return {
        lastUserMessageRef,
        lastApiResponseRef,
        lastUserInputIndex,
        lastApiResponseIndex
    };
}
import {type RefObject, useCallback, useEffect, useLayoutEffect, useRef} from "react";

import type {GetSemanticSearchStoreResponseDto} from "../types/GetSemanticSearchStoreResponseDto";

const DEFAULT_SCROLL_OFFSET = 24;

export interface UseSemanticSearchConversationScrollOptions {
    scrollOffset?: number;
    containerRef?: RefObject<HTMLElement | null>;
}

export function useSemanticSearchConversationScroll(
    semanticSearchHistory: GetSemanticSearchStoreResponseDto | undefined,
    options: UseSemanticSearchConversationScrollOptions = {}
) {
    const {scrollOffset = DEFAULT_SCROLL_OFFSET, containerRef} = options;

    const lastUserMessageRef = useRef<HTMLDivElement>(null);
    const lastApiResponseRef = useRef<HTMLDivElement>(null);
    const userHasScrolledRef = useRef(false);
    const lastScrollTopRef = useRef(0);

    const lastUserInputIndex = semanticSearchHistory
        ? semanticSearchHistory.reduce((lastIndex, item, index) => (item.type === "USER_INPUT" ? index : lastIndex), -1)
        : -1;

    const lastApiResponseIndex = semanticSearchHistory
        ? semanticSearchHistory.reduce((lastIndex, item, index) => (item.type === "API_RESPONSE" && index > lastUserInputIndex ? index : lastIndex), -1)
        : -1;

    const scrollToLastUserMessage = useCallback(
        (behavior: ScrollBehavior = "smooth") => {
            const target = lastUserMessageRef.current;
            if (!target) return;

            if (containerRef?.current) {
                const container = containerRef.current;
                const targetRect = target.getBoundingClientRect();
                const containerRect = container.getBoundingClientRect();
                const relativeTop = targetRect.top - containerRect.top;
                const newScrollTop = container.scrollTop + relativeTop - scrollOffset;

                userHasScrolledRef.current = false;
                lastScrollTopRef.current = Math.max(0, newScrollTop);

                container.scrollTo({
                    top: lastScrollTopRef.current,
                    behavior
                });
            } else {
                const targetRect = target.getBoundingClientRect();
                const scrollTop = window.scrollY || document.documentElement.scrollTop;
                const targetPosition = targetRect.top + scrollTop - scrollOffset;

                window.scrollTo({
                    top: Math.max(0, targetPosition),
                    behavior
                });
            }
        },
        [containerRef, scrollOffset]
    );

    useLayoutEffect(() => {
        const useContainer = Boolean(containerRef);
        const id = useContainer ? window.setTimeout(() => scrollToLastUserMessage("auto"), 80) : requestAnimationFrame(() => scrollToLastUserMessage("auto"));

        return () => (useContainer ? clearTimeout(id as number) : cancelAnimationFrame(id as number));
    }, [lastUserInputIndex, lastApiResponseIndex, scrollToLastUserMessage, containerRef]);

    useEffect(() => {
        const container = containerRef?.current;
        const lastApiResponseEl = lastApiResponseRef.current;
        const lastUserMessageEl = lastUserMessageRef.current;

        if (!lastApiResponseEl || !lastUserMessageEl) return;

        const handleUserScroll = () => {
            if (!container) return;

            const currentScrollTop = container.scrollTop;

            if (Math.abs(currentScrollTop - lastScrollTopRef.current) > 10) {
                userHasScrolledRef.current = true;
            }
        };

        const handleResize = () => {
            if (!userHasScrolledRef.current) {
                scrollToLastUserMessage("smooth");
            }
        };

        const resizeObserver = new ResizeObserver(handleResize);

        resizeObserver.observe(lastApiResponseEl);
        resizeObserver.observe(lastUserMessageEl);

        if (container) {
            resizeObserver.observe(container);
            container.addEventListener("scroll", handleUserScroll, {passive: true});
        }

        window.addEventListener("resize", handleResize);

        return () => {
            resizeObserver.disconnect();

            window.removeEventListener("resize", handleResize);

            if (container) {
                container.removeEventListener("scroll", handleUserScroll);
            }
        };
    }, [lastUserInputIndex, lastApiResponseIndex, scrollToLastUserMessage, containerRef]);

    useEffect(() => {
        if (!semanticSearchHistory || semanticSearchHistory.length === 0) return;

        userHasScrolledRef.current = false;

        const timeoutId = setTimeout(() => {
            scrollToLastUserMessage("smooth");
        }, 100);

        return () => clearTimeout(timeoutId);
    }, [semanticSearchHistory, scrollToLastUserMessage]);

    return {
        lastUserMessageRef,
        lastApiResponseRef,
        lastUserInputIndex,
        lastApiResponseIndex
    };
}
